// extracted by css-extract-rspack-plugin
export default {"cls1":"TruncateHeight-cls1_Vyh","cls2":"TruncateHeight-cls2_KcG TruncateHeight-cls1_Vyh"};